<style>
.page-item{
        cursor:pointer;
}
.skeleton-line {
  height: 14px;
  width: 100%;
  background: linear-gradient(
    90deg,
    #eeeeee 25%,
    #dddddd 37%,
    #eeeeee 63%
  );
  background-size: 400% 100%;
  animation: skeleton-loading 1.4s ease infinite;
  border-radius: 4px;
}

@keyframes skeleton-loading {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: 0 0;
  }
}

.text-muted i {
  color: #999;
}

/* MODE COMPACT */
.compact-table th,
.compact-table td {
  padding: 4px 6px !important;
  font-size: 12px;
}

.compact-table th {
  white-space: normal;
  line-height: 1.2;
}

.compact-table td.text-right {
  font-size: 12px;
}

.table tbody tr td:last-child,
.table thead tr th:last-child {
  padding-right: 0.5rem !important;
}

</style>

<template>
  <section class="content">
    <div class="container-fluid">
		<div class="row">
            <div class="col-12">
                <h3 class="card-title">Laporan Penambahan Persediaan</h3>
            </div>  
        </div>
		
		<!-- TOOLBAR FILTER -->
		<div class="d-flex justify-content-between align-items-center mb-2">

		  <!-- KIRI -->
		  <div class="d-flex align-items-center flex-nowrap">

			<!-- DATE FROM -->
			  <div class="d-flex align-items-center mr-2">
				<label class="mb-0 font-weight-bold">Dari</label>
				<input
				  type="date"
				  v-model="dateFrom"
				  class="form-control form-control-sm"
				  @change="loadData"
				/>
			  </div>

			  <!-- DATE TO -->
			  <div class="d-flex align-items-center mr-3">
				<label class="mb-0 font-weight-bold">Sampai</label>
				<input
				  type="date"
				  v-model="dateTo"
				  class="form-control form-control-sm"
				  @change="loadData"
				/>
			  </div>

			<!-- UNIT KERJA -->
			<div
			  v-if="isAdmin && user"
			  class="d-flex align-items-center mr-3"
			>
			  <label class="mb-0 font-weight-bold mr-1 text-nowrap">
				Unit Kerja
			  </label>
			  <select
				v-model="unitKerja"
				class="form-control form-control-sm"
				style="min-width:180px"
				@change="loadData"
			  >
				<option :value="user.unit_kerja_id">
				  {{ user.unit_kerja_nama }} (Unit Saya)
				</option>
				<option value="uk">Semua Unit Kerja</option>
				<option
				  v-for="uk in unitKerjaList"
				  :key="uk.id"
				  :value="uk.id"
				  v-if="uk.id !== user.unit_kerja_id"
				>
				  {{ uk.nama }}
				</option>
			  </select>
			</div>

			<!-- EXPORT -->
			<button
			  type="button"
			  :disabled="loadingExport"
			  class="btn btn-sm btn-success text-nowrap"
			  @click="exportExcel"
			>
				<span v-if="loadingExport">
					⏳ Sedang menyiapkan File Excel...
				</span>
				<span v-else>
					<i class="fas fa-file-excel mr-1"></i>
					Download Excel
				</span>
			  
			</button>

		  </div>

		</div>
		

      <!-- TABLE -->
	  <div class="row">
        <div class="col-12">
		  <div class="card">
						  
			<div class="card-body table-responsive p-0">
			  <table class="table table-bordered table-hover" :class="{ 'compact-table': showUnit }">
				<thead class="thead-dark">
				  <tr>
					<th style="width:50px">No</th>
					<th v-if="showUnit">Unit Kerja</th>
					<th>Kode Rekening</th>
					<th>Nama Rekening</th>
					<th class="text-right">APBD</th>
					<th class="text-right">BLUD</th>
					<th class="text-right">HIBAH</th>
					<th class="text-right">BTT</th>
					<th class="text-right">DROPPING</th>
					<th class="text-right">BOK</th>
					<th class="text-right">TOTAL</th>
				  </tr>
				</thead>
				<tbody>
					<!-- SKELETON -->
					<template v-if="isLoadingTable">
						<tr v-for="n in 5" :key="'sk-'+n">
						  <td colspan="10">
							<div class="skeleton-line"></div>
						  </td>
						</tr>
					</template>

					<!-- DATA KOSONG -->
					<tr v-else-if="isDataKosong">
						<td colspan="10" class="text-center text-muted py-4">
						  <i class="fa fa-info-circle mr-1"></i>
						  Belum ada transaksi barang masuk pada periode ini
						</td>
					</tr>
					
				  <template v-for="(item, idx) in groupedRows" :key="idx">

					  <!-- ================= DATA ================= -->
					  <template v-if="item.type === 'data'">
						<tr @click="toggleDetail(item.index)" style="cursor:pointer">
						  <td>{{ item.index + 1 }}</td>
						  <td v-if="showUnit">{{ item.data.unit_kerja }}</td>
						  <td>{{ item.data.kode }}</td>
						  <td>{{ item.data.nama }}</td>
						  <td class="text-right">{{ returnRupiahBulat(item.data.APBD) }}</td>
						  <td class="text-right">{{ returnRupiahBulat(item.data.BLUD) }}</td>
						  <td class="text-right">{{ returnRupiahBulat(item.data.HIBAH) }}</td>
						  <td class="text-right">{{ returnRupiahBulat(item.data.BTT) }}</td>
						  <td class="text-right">{{ returnRupiahBulat(item.data.DROPPING) }}</td>
						  <td class="text-right">{{ returnRupiahBulat(item.data.BOK) }}</td>
						  <td class="text-right">{{ returnRupiahBulat(item.data.TOTAL_REKAP) }}</td>
						  
						</tr>

						<!-- DETAIL -->
						<tr v-if="expandedRows.includes(item.index)">
						  <td :colspan="showUnit ? 10 : 9" class="bg-light">
							<strong>Detail Barang Masuk</strong>
							<table class="table table-sm mt-2">
							  <thead>
								<tr>
								  <th>Tanggal</th>
								  <th>Nama Barang</th>
								  <th>Qty</th>
								  <th>Harga</th>
								  <th>Total</th>
								</tr>
							  </thead>
							  <tbody>
								<tr v-for="(d, i) in rows[item.index].details" :key="i">
								  <td>{{ d.tanggal }}</td>
								  <td>{{ d.nama_barang }}</td>
								  <td class="text-right">{{ d.qty }}</td>
								  <td class="text-right">{{ returnRupiahAsli(d.harga) }}</td>
								  <td class="text-right">{{ returnRupiahBulat(d.total) }}</td>
								</tr>
							  </tbody>
							</table>
						  </td>
						</tr>
					  </template>

					  <!-- ================= SUBTOTAL PER KODE ================= -->
					  <!--<tr
						v-else-if="item.type === 'subtotal-kode'"
						class="font-weight-bold bg-warning"
					  >
						<td :colspan="showUnit ? 4 : 3">
						  {{ item.label }}
						</td>
						<td class="text-right">{{ returnRupiahBulat(item.APBD) }}</td>
						<td class="text-right">{{ returnRupiahBulat(item.BLUD) }}</td>
						<td class="text-right">{{ returnRupiahBulat(item.HIBAH) }}</td>
						<td class="text-right">{{ returnRupiahBulat(item.BTT) }}</td>
						<td class="text-right">{{ returnRupiahBulat(item.DROPPING) }}</td>
						<td class="text-right">{{ returnRupiahBulat(item.BOK) }}</td>
					  </tr>
						-->
					  <!-- ================= SUBTOTAL PER UNIT ================= -->
					  <tr
						v-else-if="item.type === 'subtotal-unit'"
						class="font-weight-bold bg-info text-white"
					  >
						<td :colspan="showUnit ? 4 : 3">
						  {{ item.label }}
						</td>
						<td class="text-right">{{ returnRupiahBulat(item.APBD) }}</td>
						<td class="text-right">{{ returnRupiahBulat(item.BLUD) }}</td>
						<td class="text-right">{{ returnRupiahBulat(item.HIBAH) }}</td>
						<td class="text-right">{{ returnRupiahBulat(item.BTT) }}</td>
						<td class="text-right">{{ returnRupiahBulat(item.DROPPING) }}</td>
						<td class="text-right">{{ returnRupiahBulat(item.BOK) }}</td>
					  </tr>

					</template>

				  
				  <!-- GRAND TOTAL -->
					<tr
					  v-if="!isLoadingTable && rows.length > 0"
					  class="font-weight-bold bg-light"
					>
					  <td :colspan="showUnit ? 4 : 3" class="text-center">
						GRAND TOTAL
					  </td>
					  <td class="text-right">{{ returnRupiahBulat(grandTotal.APBD) }}</td>
					  <td class="text-right">{{ returnRupiahBulat(grandTotal.BLUD) }}</td>
					  <td class="text-right">{{ returnRupiahBulat(grandTotal.HIBAH) }}</td>
					  <td class="text-right">{{ returnRupiahBulat(grandTotal.BTT) }}</td>
					  <td class="text-right">{{ returnRupiahBulat(grandTotal.DROPPING) }}</td>
					  <td class="text-right">{{ returnRupiahBulat(grandTotal.BOK) }}</td>
					  <td class="text-right">{{ returnRupiahBulat(grandTotal.TOTAL) }}</td>
					</tr>
				</tbody>
			  </table>
			</div>
		  </div>
		</div>
	</div>	
    </div>
  </section>
</template>

<script>
export default {
  data() {
	const now = new Date()
    return {
      dateFrom: new Date(now.getFullYear(), now.getMonth(), 1).toISOString().substr(0,10),
		dateTo: now.toISOString().substr(0,10),
      unitKerja: null,
      unitKerjaList: [],
      rows: [],
      expandedRows: [],
      isAdmin: false,
      isLoadingTable: false,
      searchTerm: '',
      perPage: 20,
      currentPage: 1,
	  loadingExport: false,
    }
  },

  computed: {
	grandTotal() {
	  return this.rows.reduce((tot, r) => {

		const totalRow =
		  Number(r.APBD || 0) +
		  Number(r.BLUD || 0) +
		  Number(r.HIBAH || 0) +
		  Number(r.BTT || 0) +
		  Number(r.DROPPING || 0) +
		  Number(r.BOK || 0)

		tot.APBD += Number(r.APBD || 0)
		tot.BLUD += Number(r.BLUD || 0)
		tot.HIBAH += Number(r.HIBAH || 0)
		tot.BTT += Number(r.BTT || 0)
		tot.DROPPING += Number(r.DROPPING || 0)
		tot.BOK += Number(r.BOK || 0)

		tot.TOTAL += totalRow // 🔥 ini kuncinya

		return tot

	  }, {
		APBD: 0,
		BLUD: 0,
		HIBAH: 0,
		BTT: 0,
		DROPPING: 0,
		BOK: 0,
		TOTAL: 0
	  })
	},
	
	groupedRows() {
	  const result = []
	  let lastUnit = null
	  let lastKode = null
	  let subtotalKode = null
	  let subtotalUnit = null

	  this.rows.forEach((row, index) => {

		// ===== SUBTOTAL PER UNIT KERJA =====
		if (this.showUnit && lastUnit !== row.unit_kerja && lastUnit !== null) {
		  result.push({
			type: 'subtotal-unit',
			label: `Subtotal ${lastUnit}`,
			...subtotalUnit
		  })
		  subtotalUnit = null
		}

		// ===== SUBTOTAL PER KODE REKENING =====
		if (
		  lastKode !== null &&
		  (lastKode !== row.kode || (this.showUnit && lastUnit !== row.unit_kerja))
		) {
		  result.push({
			type: 'subtotal-kode',
			label: `Subtotal ${lastKode}`,
			...subtotalKode
		  })
		  subtotalKode = null
		}

		// ===== INIT SUBTOTAL =====
		if (!subtotalKode) {
		  subtotalKode = {
			APBD: 0, BLUD: 0, HIBAH: 0, BTT: 0, DROPPING: 0, BOK: 0
		  }
		}

		if (this.showUnit && !subtotalUnit) {
		  subtotalUnit = {
			APBD: 0, BLUD: 0, HIBAH: 0, BTT: 0, DROPPING: 0, BOK: 0
		  }
		}

		// ===== TAMBAH NILAI =====
		;['APBD','BLUD','HIBAH','BTT','DROPPING','BOK'].forEach(k => {
		  subtotalKode[k] += Number(row[k] || 0)
		  if (this.showUnit) subtotalUnit[k] += Number(row[k] || 0)
		})

		// ===== PUSH ROW DATA =====
		result.push({
		  type: 'data',
		  data: row,
		  index
		})

		lastKode = row.kode
		lastUnit = row.unit_kerja
	  })

	  // ===== PUSH SUBTOTAL TERAKHIR =====
	  if (subtotalKode) {
		result.push({
		  type: 'subtotal-kode',
		  label: `Subtotal ${lastKode}`,
		  ...subtotalKode
		})
	  }

	  if (this.showUnit && subtotalUnit) {
		result.push({
		  type: 'subtotal-unit',
		  label: `Subtotal ${lastUnit}`,
		  ...subtotalUnit
		})
	  }

	  return result
	},

    user() {
      return this.$gate.user || null
    },

    showUnit() {
      return this.unitKerja === 'uk'
    },

    isDataKosong() {
      return (
        !this.isLoadingTable &&
        this.rows.length === 0
      )
    },

    filteredRows() {
      if (!this.searchTerm) return this.rows

      const q = this.searchTerm.toLowerCase()
      return this.rows.filter(r =>
        r.kode.toLowerCase().includes(q) ||
        r.nama.toLowerCase().includes(q) ||
        (r.unit_kerja && r.unit_kerja.toLowerCase().includes(q))
      )
    },

    paginatedRows() {
      const start = (this.currentPage - 1) * this.perPage
      return this.filteredRows.slice(start, start + this.perPage)
    }
  },

  watch: {
    user: {
      immediate: true,
      handler(user) {
        if (!user) return

        this.isAdmin = this.$gate.isAdmin() || this.$gate.isOpd()
        this.unitKerja = user.unit_kerja_id

        if (this.isAdmin) {
          this.loadUnitKerja()
        }
      }
    },
  },

  created() {
    /*const now = new Date().getFullYear()
    for (let i = 0; i < 2; i++) {
      this.tahunList.push(now - i)
    }*/
  },

  methods: {
    loadUnitKerja() {
      axios.get('/api/unit_kerja/list')
        .then(r => {
          this.unitKerjaList = r.data
        })
    },
	
	returnRupiahAsli(val){
				if (val === null || val === undefined || val === '') return '0,00';

				return new Intl.NumberFormat('id-ID', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}).format(val);
	},

	/*
	returnRupiahBulat(val){
				if (val === null || val === undefined || val === '') return '0,00';

				let angka = parseFloat(val);
				let decimal = angka - Math.floor(angka);

				if (decimal >= 0.5) {
					angka = Math.ceil(angka);
				} else {
					angka = Math.floor(angka);
				}

				return new Intl.NumberFormat('id-ID', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}).format(angka);
	},*/
	
	returnRupiahBulat(val){
				return Number(val).toLocaleString('id-ID', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				});
			},
	
			
    loadData() {
     // if (!this.tahun || !this.unitKerja) return

      this.isLoadingTable = true
      this.rows = []
      this.expandedRows = []

      const params = {
        //tahun: this.tahun,
		fromDate:this.dateFrom,
        toDate:this.dateTo,
        unit_kerja_id: this.unitKerja === 'uk' ? null : this.unitKerja
      }

      axios.get('/api/lappembelian/preview', { params })
        .then(r => {
          this.rows = r.data.map(item => ({
			kategori_id: item.kategori_id,
			unit_kerja: item.nama_unit_kerja || '',
			kode: item.kode_rekening,
			nama: item.nama_kode_rekening,
			APBD: item.APBD,
			BLUD: item.BLUD,
			HIBAH: item.HIBAH,
			BTT: item.BTT,
			DROPPING: item.DROPPING,
			BOK: item.BOK,
			TOTAL_REKAP:
			['APBD','BLUD','HIBAH','BTT','DROPPING','BOK']
				.reduce((t,k)=>t+Number(item[k]||0),0),
				
			/*TOTAL_REKAP:
			  (item.APBD || 0) +
			  (item.BLUD || 0) +
			  (item.HIBAH || 0) +
			  (item.BTT || 0) +
			  (item.DROPPING || 0) +
			  (item.BOK || 0),*/
			details: []
          }))
        })
        .finally(() => {
          this.isLoadingTable = false
        })
    },

    toggleDetail(index) {
      const i = this.expandedRows.indexOf(index)

	  if (i > -1) {
		this.expandedRows.splice(i, 1)
		return
	  }

	  this.expandedRows.push(index)

	  if (this.rows[index].details.length > 0) return

	  axios.get('/api/lappembelian/detail', {
		params: {
		  fromDate:this.dateFrom,
		  toDate:this.dateTo,
		  kategori_id: this.rows[index].kategori_id,
		  unit_kerja_id: this.unitKerja === 'uk' ? null : this.unitKerja
		}
	  }).then(r => {
		this.rows[index].details = r.data
	  })
    },

    /*exportExcel() {
			const params = new URLSearchParams({
			fromDate: this.dateFrom,
			toDate: this.dateTo,
			unit_kerja_id: this.unitKerja === 'uk' ? '' : this.unitKerja
		  }).toString()

		this.loadingExport = true
		  window.open(`/api/lappembelian/export?${params}`, '_blank')
		  
		  setTimeout(() => {
		  this.loadingExport = false
		}, 2000)
    },*/
	
	async exportExcel() {
	  try {
		this.loadingExport = true   // 🔥 mulai loading
		
		const params = {
		  fromDate: this.dateFrom,
		  toDate: this.dateTo,
		  unit_kerja_id: this.unitKerja === 'uk' ? '' : this.unitKerja
		}

		const res = await axios.get('/api/lappembelian/export', {
		  params,
		  responseType: 'blob'
		})

		const blob = new Blob([res.data], { type: res.headers['content-type'] })
		const url = window.URL.createObjectURL(blob)

		// ✅ ambil nama file dari header Laravel
		let filename = `lap_pembelian_${this.dateFrom}_sd_${this.dateTo}.xlsx`

		const disposition = res.headers['content-disposition']
		if (disposition && disposition.indexOf('filename=') !== -1) {
		  filename = disposition
			.split('filename=')[1]
			.replace(/"/g, '')
		}

		const a = document.createElement('a')
		a.href = url
		a.download = filename
		document.body.appendChild(a)
		a.click()

		window.URL.revokeObjectURL(url)
	  } catch (err) {
		console.error(err)
		this.$toast?.error('Gagal download Excel')
	  }finally {
		this.loadingExport = false  // ✅ selesai loading
	  }
	},

    changePageRange() {
      this.currentPage = 1
    },

    format(val) {
      //return Number(val || 0).toLocaleString('id-ID')
	  if (val === null || val === undefined || val === '') return 0;

				return new Intl.NumberFormat('id-ID', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2, // tetap tampil .5 / .50
				}).format(val);
    }
  }
}
</script>